import React from 'react'
import { CMSOpportunityDetailsSourceCountriesType } from '../../../lib/types'
import { CMSCardTextImageLayout } from './cms-card-text-image-layout'

const CMSSourceCountries = ({
  sourceCountries,
}: {
  sourceCountries?: CMSOpportunityDetailsSourceCountriesType
}) => {
  if (
    !sourceCountries?.sourceCountryText?.length ||
    !sourceCountries.sourceCountryImage ||
    !sourceCountries.sourceCountryImagePosition
  ) {
    return null
  }

  return (
    <CMSCardTextImageLayout
      imagePosition={sourceCountries.sourceCountryImagePosition}
      image={sourceCountries.sourceCountryImage}
      cardText={sourceCountries.sourceCountryText}
      dataTestId='cms-source-countries-content'
      imageAltText={'Source countries image'}
    />
  )
}

export { CMSSourceCountries }
